import React, { useContext, useEffect, useRef, useState } from "react";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import Menu from "../components/Menu.js";
import { AuthContext } from "../components/authentication/Auth.js";
import { hasPhoneNumber } from "../components/authentication/userProfiles.js";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Footer from "../components/Footer.jsx";
import {
  AccountNameFields,
  AccountPhoneField,
} from "../components/userForms/AccountDetailsFields.js";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://material-ui.com/" to="/">
        Farm-To-Plate-Marketplace
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignUp() {
  const classes = useStyles();
  const { currentUser, handleSignUp } = useContext(AuthContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submissionPending = useRef(false);
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submissionPending.current) {
      return;
    }
    const fields = e.currentTarget.elements;
    const email = fields.namedItem("email").value.trim();
    const password = fields.namedItem("password").value;
    const firstName = fields.namedItem("firstName").value.trim();
    const lastName = fields.namedItem("lastName").value.trim();
    const phoneNumber = fields.namedItem("phoneNumber").value.trim();
    const letters = /^[A-Za-z]+$/;

    if (!letters.test(firstName) || !letters.test(lastName)) {
      alert(
        "Names can only include letters.  Please correct this to create an account",
      );
      return;
    }

    if (!hasPhoneNumber(phoneNumber)) {
      alert("Enter your phone number to create an account.");
      return;
    }

    submissionPending.current = true;
    setIsSubmitting(true);
    try {
      await handleSignUp({ firstName, lastName, email, phoneNumber }, password);
    } catch (error) {
      if (!mounted.current) {
        return;
      }
      setIsSubmitting(false);
      if (error.code === "auth/weak-password") {
        alert("The password is too weak.");
      } else {
        alert(error.message);
      }
      console.log(error);
    } finally {
      submissionPending.current = false;
    }
  };

  // Registration publishes the signed-in user after the profile has been saved.
  if (currentUser) {
    return <Redirect to="/" />;
  }

  return (
    <div
      id="home"
      style={{
        background:
          "url(https://lh3.googleusercontent.com/pw/AM-JKLX9R3PirLtTHwOF3XeC06VSb-5mrTxYgcNfh_jQZ8qlXK8AJ1Pnqa8uVDQnOEpP7r0eYFK8qhTOZIrPd3QVDglHsa9CnnHZn99KoPQJIpREEoSuNtxseEaJb76wVKVssqtc3wfrq7PqiIlium2o_suH=w1186-h789-no?authuser=1)",
        backgroundSize: "contain",
      }}
    >
      <Menu />
      <Container
        style={{
          background: "white",
          border: "5px solid rgb(159, 191, 89)",
          margin: "50px auto",
          paddingBottom: "15px",
          borderRadius: "15px",
        }}
        component="main"
        maxWidth="xs"
      >
        <CssBaseline />
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign up
          </Typography>
          <form onSubmit={handleSubmit} className={classes.form} noValidate>
            <Grid container spacing={2}>
              <AccountNameFields disabled={isSubmitting} autoFocus />
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  disabled={isSubmitting}
                />
              </Grid>
              <AccountPhoneField disabled={isSubmitting} required />
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="new-password"
                  disabled={isSubmitting}
                />
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Creating account…" : "Sign Up"}
            </Button>
            <Grid container justifyContent="flex-end">
              <Grid item>
                <Link to="/SignIn" variant="body2">
                  Already have an account? Sign in
                </Link>
              </Grid>
            </Grid>
          </form>
        </div>
        <Box mt={5}>
          <Copyright />
        </Box>
      </Container>
      <Footer />
    </div>
  );
}
